import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orSpaceCharacter',
  standalone: false
})
export class OrSpaceCharacterPipe implements PipeTransform {
  transform(value: string): string {
    return value || ' ';
  }
}
